import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/skills/id/page';

export const Route = createFileRoute('/_app/_chat/skills/$id/')({
  component: Page,
});
